export enum TargetType {
  unknown = 0,
  download = 1,
  open = 2,
}
